<template>
    <table class="table table-stripe expectations-table">
        <thead>
            <tr>
                <th></th>
                <th>{{ l('EXPECTATIONS.EXPECTED') }}</th>
                <th>{{ l('EXPECTATIONS.ACTUAL') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in data"
                :key="row.label">
                <th>{{ l(row.label) }}</th>
                <th>{{ row.expected }}</th>
                <th>
                    <span class="label"
                          :class="row.actual === row.expected ? 'label-success' : 'label-danger'">
                        {{ row.actual }}
                    </span>
                </th>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
};
</script>
